import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { pdfStyles } from '../styles/pdf-styles';
import { mapRiskToEnglish, formatRiskLabel, getRiskStyleByLevel, type RiskLevel } from '../utils/risk-utils';

interface PDFRiskIndicatorProps {
  risk: string;
  showLabel?: boolean;
  size?: 'default' | 'small';
  style?: any;
}

/**
 * Reusable PDF risk indicator component
 */
export const PDFRiskIndicator: React.FC<PDFRiskIndicatorProps> = ({
  risk,
  showLabel = false,
  size = 'default',
  style,
}) => {
  const level: RiskLevel | null = mapRiskToEnglish(risk);
  if (!level) return null;
  const riskStyle = getRiskStyleByLevel(level);
  const indicatorStyle = size === 'small' ? pdfStyles.riskIndicatorSmall : pdfStyles.riskIndicator;

  if (showLabel) {
    return (
      <View style={[{ flexDirection: 'row', alignItems: 'center', gap: 5 }, style]}>
        <Text style={pdfStyles.infoValue}>{formatRiskLabel(risk)}</Text>
        <View style={[indicatorStyle, riskStyle]} />
      </View>
    );
  }

  return <View style={[indicatorStyle, riskStyle, style]} />;
};
